/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/*@ngInject*/
export default function BreadcrumbLabel($translate) {
    var labels = {};

    var breadcrumbLabel = function (bLabel) {

        var labelObj;
        labelObj = angular.fromJson(bLabel);
        if (labelObj) {
            if (!labels[labelObj.label]) {
                labels[labelObj.label] = labelObj.label;
                var translate = !(labelObj.translate && labelObj.translate === 'false');
                if (translate) {
                    $translate([labelObj.label]).then(
                        function (translations) {
                            labels[labelObj.label] = translations[labelObj.label];
                        }
                    )
                }
            }
            return labels[labelObj.label];
        } else {
            return '';
        }
    };

    breadcrumbLabel.$stateful = true;

    return breadcrumbLabel;
}



// WEBPACK FOOTER //
// ./src/app/layout/breadcrumb-label.filter.js